import { pxToEm, pxToRem } from 'src/theme/adSales/helpers'

export const breakpointsRaw = [400, 600, 900, 1008, 1280]
export const breakpoints = breakpointsRaw.map(w => `${pxToEm(w)}`)

export const gelTypeStyles = {
  atlas: {
    fontSize: [pxToRem(96), null, pxToRem(140)],
    lineHeight: [pxToRem(104), null, pxToRem(148)]
  },
  elephant: {
    fontSize: [pxToRem(78), null, pxToRem(116)],
    lineHeight: [pxToRem(84), null, pxToRem(124)]
  },
  imperial: {
    fontSize: [pxToRem(64), null, pxToRem(96)],
    lineHeight: [pxToRem(72), null, pxToRem(104)]
  },
  royal: {
    fontSize: [pxToRem(52), null, pxToRem(76)],
    lineHeight: [pxToRem(60), null, pxToRem(84)]
  },
  foolscap: {
    fontSize: [pxToRem(40), null, pxToRem(56)],
    lineHeight: [pxToRem(44), null, pxToRem(60)]
  },
  canon: {
    fontSize: [pxToRem(32), null, pxToRem(44)],
    lineHeight: [pxToRem(36), null, pxToRem(48)]
  },
  trafalgar: {
    fontSize: [pxToRem(24), null, pxToRem(32)],
    lineHeight: [pxToRem(28), null, pxToRem(36)]
  },
  paragon: {
    fontSize: [pxToRem(22), null, pxToRem(28)],
    lineHeight: [pxToRem(26), null, pxToRem(32)]
  },
  doublePica: {
    fontSize: [pxToRem(20), null, pxToRem(24)],
    lineHeight: [pxToRem(24), null, pxToRem(28)]
  },
  greatPrimer: {
    fontSize: [pxToRem(18), null, pxToRem(20)],
    lineHeight: [pxToRem(22), null, pxToRem(24)]
  },
  bodyCopy: {
    fontSize: [pxToRem(16), null, pxToRem(16)],
    lineHeight: [pxToRem(22), null, pxToRem(22)]
  },
  pica: {
    fontSize: [pxToRem(16), null, pxToRem(16)],
    lineHeight: [pxToRem(20), null, pxToRem(20)]
  },
  longPrimer: {
    fontSize: [pxToRem(16), null, pxToRem(16)],
    lineHeight: [pxToRem(18), null, pxToRem(18)]
  },
  brevier: {
    fontSize: [pxToRem(14), null, pxToRem(13)],
    lineHeight: [pxToRem(18), null, pxToRem(16)]
  },
  minion: {
    fontSize: [pxToRem(12), null, pxToRem(12)],
    lineHeight: [pxToRem(16), null, pxToRem(16)]
  }
}
